import React from "react";
import TenantService from "../../../services/core/TenantService";
import { faSitemap } from "@fortawesome/free-solid-svg-icons";
import CrudManager from "../../../components/common/CrudManager";

const Tenant = () => {
  // Definir columnas - estructura APLANADA (ultra-simple)
  const columns = [
    {
      key: "code",
      label: "tenant.code",
      sortable: true,
      // Formulario:
      showInForm: true,
      type: "text",
      placeholder: "tenant.codePlaceholder",
      required: true,
      // Filtro:
      showInFilter: true,
      filterSize: "small",
    },
    {
      key: "name",
      label: "tenant.name",
      sortable: true,
      // Formulario:
      showInForm: true,
      type: "text",
      placeholder: "tenant.namePlaceholder",
      required: true,
      icon: "fa-building",
      // Filtro:
      showInFilter: true,
      filterSize: "large",
    },
    {
      key: "status",
      label: "tenant.status",
      sortable: true,
      showInForm: true,
      type: "select",
      options: [
        { value: "active", label: "tenant.statusActive" },
        { value: "disabled", label: "tenant.statusDisabled" },
      ],
      showInFilter: true,
      filterSize: "small",
    },
    {
      key: "mfaRequired",
      label: "tenant.mfaRequired",
      showInForm: true,
      type: "checkbox",
    },
  ];

  return (
    <CrudManager
      service={TenantService}
      columns={columns}
      entityName="tenant"
      icon={faSitemap}
      formLayout="modal"
      initialFormData={{ status: "active" }}
    />
  );
};

export default Tenant;
